import HotWalletDetailsTableView from './hotWalletDetailsTableView';

export default HotWalletDetailsTableView;
